import { Sparkles } from "lucide-react";
import { MARQUEE_ITEMS } from "../lib/data";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-sky-100 bg-sky-50/60 py-5 overflow-hidden select-none"
    >
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-10 font-heading text-sm font-bold uppercase tracking-[0.25em] text-slate-400"
          >
            {item}
            <Sparkles size={14} className="text-sky-400" />
          </span>
        ))}
      </div>
    </div>
  );
};
